import { Reveal, Overline } from "../Reveal";

const OFFER = [
  {
    k: "The opportunity",
    v: "A new Italian luxury brand — agile, focused, dedicated to the Gulf from day one.",
  },
  {
    k: "Partnership model",
    v: "We seek one established luxury partner to build the brand side by side.",
  },
  {
    k: "Potential exclusivity",
    v: "Forms of regional exclusivity to be defined jointly with the chosen partner.",
  },
  {
    k: "Shared growth",
    v: "Collections, capsules and storytelling co-developed — the partner helps shape the brand as it grows.",
  },
];

export default function Slide08Retail() {
  return (
    <section className="slide bg-[var(--ais-cream-2)]" data-testid="slide-08">
      <div className="min-h-screen flex items-center px-6 md:px-16 lg:px-24 py-24">
        <div className="w-full max-w-6xl mx-auto">
          <Reveal>
            <Overline>08 — Retail Opportunity</Overline>
          </Reveal>
          <Reveal delay={1}>
            <div className="hairline w-16 my-8" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-espresso)] leading-[1.05] tracking-[-0.01em] font-light max-w-4xl">
              Not a product line —
              <br />
              <em className="italic">a brand</em> to build together.
            </h2>
          </Reveal>
          <Reveal delay={3}>
            <p className="mt-10 font-sans text-[var(--ais-text)] text-base md:text-lg max-w-2xl leading-[1.85] font-light">
              AIS is not a wholesale catalogue. It is the chance, for the right
              Gulf partner, to co-develop a new Italian luxury house shaped
              around the region from inception — with the agility of a young
              maison and the rigour of a heritage one.
            </p>
          </Reveal>

          <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8 max-w-4xl">
            {OFFER.map((r, i) => (
              <Reveal key={r.k} delay={4 + i}>
                <div className="flex flex-col gap-3 border-b border-[var(--ais-gold-soft)] pb-6">
                  <span className="font-sans text-[0.65rem] tracking-luxe uppercase text-[var(--ais-leather)]">
                    {r.k}
                  </span>
                  <span className="font-serif italic text-xl md:text-2xl text-[var(--ais-espresso)] font-light leading-snug">
                    {r.v}
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
